import Teaser from "./teaser";
import { RessortModuleEntry } from "../helper/interfaces";
import { Globe, Star, List, Heart } from "react-feather";
import { isMobile } from "react-device-detect";
import React from "react";
import {
  ContentType,
  AppTheme,
  TeaserViewType,
  ListIconsEnum,
} from "../helper/enums";
import TeaserListHeader from "./TeaserList/TeaserListHeader";
import TeaserMinimizedView from "./teaserMinimizedView";
import SearchModule from "./SearchModule";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import TeaserTickerView from "./TeaserTickerView";
import TeaserMinimizedContainerNN from "./teaserMinimizedContainerNN";
import LoadMore from "./LoadMore";
import TeaserPlaceholderList from "./TeaserPlaceholderList";
import { getLinkObjectFromModule } from "../helper/link";
import LinkedModuleTitle from "./LinkedModuleTitle";
import ModuleLinkList from "./ModuleLinkList";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

interface Data {
  module: RessortModuleEntry;
  moduleIndex: number;
  navigate: (id?: string, ressortId?: string, moduleId?: string, doNotStoreArticleId?: boolean) => void;
  loadMore: (id: string, searchParams?: any, restPage?: boolean) => void;
  pageInformation: any;
  isLoadingMore: boolean;
}

const LIST_ICONS: Record<string, React.ReactNode> = {
  [ListIconsEnum.Star]: <Star />,
  [ListIconsEnum.List]: <List />,
  [ListIconsEnum.Globe]: <Globe />,
  [ListIconsEnum.Heart]: <Heart />,
};

const CustomDot = ({ active, onClick, carouselState, index }) => {
  const { currentSlide } = carouselState;

  return (
    <li
      key={index}
      onClick={onClick}
      className={`storymodule-custom-dot ${
        active || currentSlide >= index ? "storymodule-custom-dot--active" : "storymodule-custom-dot--inactive"
      }`}
    />
  );
};

function ModuleComponent(data: Data) {
  const moduleData = data.module;
  const navigate = data.navigate;
  const loadMore = data.loadMore;
  const pageInformation = data.pageInformation;
  const isLoadingMore = data.isLoadingMore;
  const moduleIndex = data.moduleIndex;

  const CustomDotWrapper = (props: any) => <CustomDot {...props} />;

  const ignoreLead = process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nn ? true : false;

  const isNN = process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nn ? true : false;

  const linkObject = getLinkObjectFromModule(moduleData);

  return (
    <React.Fragment key={`o-${moduleData.id}-${data.moduleIndex}`} >
      <div
        data-name={`module-${moduleData.id}`}
        className={`teaser-list ${
          moduleData.contrastColor ? "teaser-list--contrast-color" : ""
        }`}
      >
        {moduleData.type == ContentType.MyRessortHeadline && (
          <>
          <div className="favorit flex">
            <div
              onClick={() => navigate(undefined, moduleData.id)}
              className="favorit_headline flex-1"
            >
              {moduleData.title}
            </div>
            <div className="my_favorit flex-1">
              meine <span>Favoriten</span>
            </div>
          </div>
          {moduleData.linkList && moduleData.linkList.length > 0 && (
            <ModuleLinkList moduleId={moduleData.id} linkList={moduleData.linkList} navigate={navigate} />
          )}
          </>
        )}
        {moduleData.type == ContentType.MyRessortLoadRessort && (
          <div
            className="more-arrow-btn"
            onClick={() => navigate(undefined, moduleData.id)}
          >
            {" "}
            <span className="more-arrow-btn_title">
              Mehr zu {moduleData.title}
            </span>
          </div>
        )}
        {moduleData.type != ContentType.MyRessortLoadRessort &&
          moduleData.type != ContentType.MyRessortHeadline && (
            <React.Fragment>
              {moduleData.title &&
                moduleData.type != ContentType.SearchModule &&
                moduleData.type != ContentType.ListModule && (
                  <>
                    <TeaserListHeader>
                      <LinkedModuleTitle link={linkObject} title={moduleData.title} moduleId={moduleData.id} navigate={navigate}/>
                    </TeaserListHeader>
                    {moduleData.linkList && moduleData.linkList.length > 0 && (
                      <ModuleLinkList moduleId={moduleData.id} linkList={moduleData.linkList} navigate={navigate} />
                    )}
                    </>
                )}
              <div>
                {moduleData.type == ContentType.SearchModule && (
                  <SearchModule
                    module={moduleData}
                    search={(searchParams?: any) =>
                      loadMore(moduleData.id, searchParams, true)
                    }
                  />
                )}
                {moduleData.type == ContentType.SearchModule &&
                  moduleData.teasers?.length < 1 &&
                  !isLoadingMore && (
                    <div>Ihre Suche ergab leider keine Treffer.</div>
                  )}
                {moduleData.elementsViewType === "slider" &&
                  moduleData.type !== ContentType.StoryModule && (
                    <Carousel responsive={responsive} swipeable={true}>
                      {moduleData.teasers.map((teaser, indexTeaser) => (
                        <React.Fragment
                          key={`teasers-teaser-key-${teaser.id}-${moduleData.id}-${moduleIndex}-${indexTeaser}`}
                        >
                          {teaser.type != ContentType.Unknown &&
                            teaser.minimizedView != true && (
                              <Teaser
                                teaser={teaser}
                                ignoreLead={ignoreLead}
                                adInformation={pageInformation?.adInformation}
                                navigate={(id: string, ressortId: string) =>  
                                  navigate(id, ressortId, moduleData.id, true)
                                }
                              />
                            )}
                          {teaser.type != ContentType.Unknown &&
                            teaser.minimizedView == true && (
                              <TeaserMinimizedView
                                teaser={teaser}
                                ignoreLead={ignoreLead}
                                adInformation={pageInformation?.adInformation}
                                navigate={(id: string, ressortId: string) =>
                                  navigate(id, ressortId, moduleData.id, true)
                                }
                              />
                            )}
                        </React.Fragment>
                      ))}
                    </Carousel>
                  )}
                {moduleData.type == ContentType.MasonryModule && (
                  <div
                    className={`
                    teaser-list-module 
                    ${
                      moduleData.teasers.length !== 1 &&
                      moduleData.teasers.length % 2 === 0
                        ? "masonry"
                        : "masonry-column"
                    }`}
                  >
                    {moduleData.teasers.map((teaser, indexTeaser) => (
                      <React.Fragment
                        key={`teasers-teaser-key-${teaser.id}-${moduleData.id}-${moduleIndex}-${indexTeaser}`}
                      >
                        <Teaser
                          teaser={teaser}
                          ignoreLead={ignoreLead}
                          adInformation={pageInformation?.adInformation}
                          navigate={(id: string, ressortId: string) =>
                            navigate(id, ressortId)
                          }
                          viewType={TeaserViewType.Masonry}
                        />
                      </React.Fragment>
                    ))}
                  </div>
                )}
                {(moduleData.type == ContentType.ListModule) && (
                  <div
                    className={`teaser-list-module ${
                      moduleData.frame ? "teaser-list-module-type" : ""
                    }`}
                  >
                    {!isNN && moduleData.title && (
                      <div className="teaser-list__header__title">
                        <LinkedModuleTitle link={linkObject} title={moduleData.title} moduleId={moduleData.id} navigate={navigate}/>
                      </div>
                    )}
                    {isNN && moduleData.title && (
                      <div className="teaser-list__title">
                       <LinkedModuleTitle link={linkObject} title={moduleData.title} moduleId={moduleData.id} navigate={navigate}/>
                      </div>
                    )}
                    {moduleData.linkList && moduleData.linkList.length > 0 && (
                      <ModuleLinkList moduleId={moduleData.id} linkList={moduleData.linkList} navigate={navigate} />
                    )}
                    {isNN && moduleData.icon && (
                      <>
                        <div className="teaser-list__icon">
                          {LIST_ICONS[moduleData.icon] ?? ""}
                        </div>
                      </>
                    )}
                    {moduleData.teasers.map((teaser, indexTeaser) => (
                      <React.Fragment
                        key={`teasers-teaser-key-${teaser.id}-${moduleData.id}-${moduleIndex}-${indexTeaser}`}
                      >
                        {isNN &&
                        <TeaserMinimizedContainerNN
                          teaser={teaser}
                          ignoreLead={ignoreLead}
                          showImage={true}
                          adInformation={pageInformation?.adInformation}
                          navigate={(id: string, ressortId: string) =>
                            navigate(id, ressortId, moduleData.id)
                          }
                        />}
                         {!isNN &&
                        <Teaser
                          teaser={teaser}
                          ignoreLead={ignoreLead}
                          adInformation={pageInformation?.adInformation}
                          navigate={(id: string, ressortId: string) =>
                            navigate(id, ressortId, moduleData.id)
                          }
                        />}
                      </React.Fragment>
                    ))}
                    <TeaserPlaceholderList autoContentSize={moduleData.autoContentSize ?? 0} teasersLength={moduleData.teasers.length} links={moduleData.links}/>
                    <LoadMore module={moduleData} loadMore={loadMore} isLoadingMore={isLoadingMore} />
                  </div>
                )}
                {moduleData.type == ContentType.StoryModule && (
                  <div
                    className={`teaser-list-module ${
                      moduleData.teasers.filter((m) => m.images?.length > 0)
                        ?.length > 0
                        ? "slider-with-images"
                        : "slider-without-images"
                    }`}
                  >
                    <Carousel
                      responsive={responsive}
                      swipeable={true}
                      customDot={<CustomDotWrapper />}
                      showDots={
                        process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nn &&
                        isMobile
                          ? moduleData.teasers.length > 1
                          : moduleData.teasers.length > 2
                      }
                    >
                      {moduleData.teasers.map((teaser, indexTeaser) => (
                        <React.Fragment
                          key={`teasers-teaser-key-${teaser.id}-${moduleData.id}-${moduleIndex}-${indexTeaser}`}
                        >
                          {teaser.type != ContentType.Unknown &&
                            teaser.minimizedView != true && (
                              <Teaser
                                teaser={teaser}
                                ignoreLead={ignoreLead}
                                adInformation={pageInformation?.adInformation}
                                className="teaser-slider"
                                navigate={(id: string, ressortId: string) =>
                                  navigate(id, ressortId, moduleData.id, true)
                                }
                              />
                            )}
                          {teaser.type != ContentType.Unknown &&
                            teaser.minimizedView == true && (
                              <TeaserMinimizedView
                                teaser={teaser}
                                ignoreLead={ignoreLead}
                                adInformation={pageInformation?.adInformation}
                                navigate={(id: string, ressortId: string) =>
                                  navigate(id, ressortId, moduleData.id)
                                }
                              />
                            )}
                        </React.Fragment>
                      ))}
                    </Carousel>
                  </div>
                )}
                {moduleData.type == ContentType.HighlightModule && (
                  <div className="teaser-list-module highlight-module">
                    {moduleData.teasers?.length > 0 && 
                      <Teaser
                        teaser={moduleData.teasers[0]}
                        ignoreLead={ignoreLead}
                        adInformation={pageInformation?.adInformation}
                        navigate={(id: string, ressortId: string) =>
                          navigate(id, ressortId, moduleData.id)
                        }
                      />
                    }
                    {moduleData.teasers.slice(1).map((teaser, indexTeaser) => (
                      <React.Fragment
                        key={`teasers-teaser-key-${teaser.id}-${moduleData.id}-${moduleIndex}-${indexTeaser}`}
                      >
                        {isNN && <TeaserMinimizedContainerNN
                          teaser={teaser}
                          ignoreLead={ignoreLead}
                          showImage={true}
                          adInformation={pageInformation?.adInformation}
                          navigate={(id: string, ressortId: string) =>
                            navigate(id, ressortId, moduleData.id)
                          }
                        />}
                        {!isNN && <Teaser
                          teaser={teaser}
                          ignoreLead={ignoreLead}
                          adInformation={pageInformation?.adInformation}
                          navigate={(id: string, ressortId: string) =>
                            navigate(id, ressortId, moduleData.id)
                          }
                        />}
                      </React.Fragment>
                    ))}
                  </div>
                )}
                {!(
                  moduleData.type == ContentType.MasonryModule ||
                  moduleData.type == ContentType.StoryModule ||
                  moduleData.type == ContentType.ListModule ||
                  moduleData.type == ContentType.HighlightModule
                ) &&
                  moduleData.elementsViewType !== "slider" && (
                    <>
                      <div className="teaser-list-module">
                        {moduleData.teasers.map((teaser, indexTeaser) => (
                          <React.Fragment
                            key={`teasers-teaser-key-${teaser.id}-${moduleData.id}-${moduleIndex}-${indexTeaser}`}
                          >
                            {moduleData.elementsViewType !== "ticker" &&
                              teaser.type != ContentType.Unknown &&
                              teaser.minimizedView != true && (
                                <Teaser
                                  teaser={teaser}
                                  ignoreLead={ignoreLead}
                                  adInformation={pageInformation?.adInformation}
                                  navigate={(id: string, ressortId: string) =>
                                    navigate(id, ressortId, moduleData.id)
                                  }
                                />
                              )}
                            {moduleData.elementsViewType === "ticker" &&
                              teaser.type != ContentType.Unknown &&
                              teaser.minimizedView != true && (
                                <TeaserTickerView
                                  teaser={teaser}
                                  ignoreLead={ignoreLead}
                                  adInformation={pageInformation?.adInformation}
                                  navigate={(id: string, ressortId: string) =>
                                    navigate(id, ressortId, moduleData.id)
                                  }
                                />
                              )}
                            {moduleData.elementsViewType !== "ticker" &&
                              teaser.type != ContentType.Unknown &&
                              teaser.minimizedView == true && (
                                <TeaserMinimizedView
                                  teaser={teaser}
                                  ignoreLead={ignoreLead}
                                  adInformation={pageInformation?.adInformation}
                                  navigate={(id: string, ressortId: string) =>
                                    navigate(id, ressortId, moduleData.id)
                                  }
                                />
                              )}
                          </React.Fragment>
                        ))}
                      </div>
                      <TeaserPlaceholderList autoContentSize={moduleData.autoContentSize ?? 0} teasersLength={moduleData.teasers.length} links={moduleData.links}/>
                    </>
                  )}
              </div>
            </React.Fragment>
          )}
      </div>
      {moduleData.type != ContentType.ListModule &&
        <LoadMore module={moduleData} loadMore={loadMore} isLoadingMore={isLoadingMore} />
      }
    </React.Fragment>
  );
}

export default ModuleComponent;
